if (!customElements.get('price-slider')) {
  class PriceSlider extends HTMLElement {
    connectedCallback() {
      this.top = parseInt(this.dataset.max, 10) || 0;
      this.minV = parseInt(this.dataset.from, 10) || 0;
      this.maxV = parseInt(this.dataset.to, 10);
      if (isNaN(this.maxV)) this.maxV = this.top;

      this.track = this.querySelector('.prs__track');
      this.fill = this.querySelector('.prs__fill');
      this.thumbMin = this.querySelector('.prs__thumb--min');
      this.thumbMax = this.querySelector('.prs__thumb--max');
      this.bubbleMin = this.querySelector('.prs__bubble--min b');
      this.bubbleMax = this.querySelector('.prs__bubble--max b');
      const texts = this.querySelectorAll('.field__input');
      this.textMin = texts[0];
      this.textMax = texts[1];

      this.dragging = null;

      [this.thumbMin, this.thumbMax].forEach((thumb) => {
        const which = thumb === this.thumbMin ? 'min' : 'max';
        thumb.addEventListener('pointerdown', (e) => this.start(e, which, thumb));
        thumb.addEventListener('pointermove', (e) => this.move(e));
        thumb.addEventListener('pointerup', (e) => this.end(e, thumb));
        thumb.addEventListener('pointercancel', (e) => this.end(e, thumb));
        thumb.addEventListener('keydown', (e) => this.key(e, which));
      });

      // Track pe click kare to nearest pin wahan jaye
      this.track.addEventListener('pointerdown', (e) => {
        if (e.target.closest('.prs__thumb')) return;
        const v = this.valueFromX(e.clientX);
        const which = Math.abs(v - this.minV) <= Math.abs(v - this.maxV) ? 'min' : 'max';
        this.set(which, v);
        this.commit(which);
      });

      [this.textMin, this.textMax].forEach((t) => t.addEventListener('change', () => this.fromTexts()));

      this.render();
    }

    valueFromX(x) {
      const r = this.track.getBoundingClientRect();
      const pct = Math.min(Math.max((x - r.left) / r.width, 0), 1);
      return Math.round(pct * this.top);
    }

    set(which, v) {
      if (which === 'min') this.minV = Math.min(Math.max(v, 0), this.maxV);
      else this.maxV = Math.max(Math.min(v, this.top), this.minV);
      this.render();
    }

    start(e, which, thumb) {
      e.preventDefault();
      this.dragging = which;
      thumb.setPointerCapture(e.pointerId);
      thumb.classList.add('is-active');
    }

    move(e) {
      if (!this.dragging) return;
      this.set(this.dragging, this.valueFromX(e.clientX));
    }

    end(e, thumb) {
      if (!this.dragging) return;
      const which = this.dragging;
      this.dragging = null;
      thumb.classList.remove('is-active');
      try { thumb.releasePointerCapture(e.pointerId); } catch (err) {}
      this.commit(which);
    }

    key(e, which) {
      const step = e.shiftKey ? 50 : 1;
      let d = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') d = step;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') d = -step;
      if (!d) return;
      e.preventDefault();
      this.set(which, (which === 'min' ? this.minV : this.maxV) + d);
      clearTimeout(this.keyTimer);
      this.keyTimer = setTimeout(() => this.commit(which), 500);
    }

    // Text boxes update karo aur Shopify filter trigger karo
    commit(which) {
      this.textMin.value = this.minV === 0 ? '' : this.minV;
      this.textMax.value = this.maxV === this.top ? '' : this.maxV;
      const target = which === 'min' ? this.textMin : this.textMax;
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }

    fromTexts() {
      const clean = (v, d) => {
        const n = parseFloat(String(v).replace(/,/g, ''));
        return isNaN(n) ? d : Math.min(Math.max(Math.round(n), 0), this.top);
      };
      let min = clean(this.textMin.value, 0);
      let max = clean(this.textMax.value, this.top);
      if (min > max) min = max;
      this.minV = min;
      this.maxV = max;
      this.render();
    }

    render() {
      const p1 = this.top ? (this.minV / this.top) * 100 : 0;
      const p2 = this.top ? (this.maxV / this.top) * 100 : 100;
      this.thumbMin.style.left = p1 + '%';
      this.thumbMax.style.left = p2 + '%';
      this.fill.style.left = p1 + '%';
      this.fill.style.width = p2 - p1 + '%';
      this.style.setProperty('--p1', p1);
      this.style.setProperty('--p2', p2);
      this.bubbleMin.textContent = this.minV;
      this.bubbleMax.textContent = this.maxV;
      this.thumbMin.setAttribute('aria-valuenow', this.minV);
      this.thumbMax.setAttribute('aria-valuenow', this.maxV);
      // Dono pin overlap ho to jo nikal sake wahi upar rahe
      const overlap = this.minV === this.maxV;
      const atEnd = this.maxV === this.top;
      this.thumbMin.style.zIndex = overlap && atEnd ? 4 : 2;
      this.thumbMax.style.zIndex = overlap && atEnd ? 2 : 3;
    }
  }
  customElements.define('price-slider', PriceSlider);
}